export default "__VITE_ASSET__c5454cde__"